
<div class="wccard mb-1 p-2" >
  <div class="d-flex mb-1">
    <ng-content select="[talentPoolBulkGrab]"></ng-content>
    <div>
      <!-- <div *ngIf="!this.aiSourcingService.isAISourcingTab"  class="circular-img mr-3 mb-3 text-capitalize position-relative" [ngClass]="{
                'lavender-circle': index % 5 == 0,
                'yellow-circle': index % 5 == 1,
                'blue-circle': index % 5 == 2,
                'teal-circle': index % 5 == 3,
                'pink-circle': index % 5 == 4
              }">{{transform(data.full_name).charAt(0)}}
      </div> -->
    </div>
    <div class="d-flex justify-content-between" style="width: calc(100% - 25px);">
      <div class="w-100">
        <div class="d-flex justify-content-between">
          <div style="max-width: 58%;">
            <span class="d-flex align-items-baseline mb-1">
              <span class="f-16 font-weight-500 text-capitalize f-16 font-weight-600 pointer text-truncate"
                (click)="handleChildEvents('openNav')" [innerHTML]="transform(data.full_name)" *ngIf="data?.full_name">
            </span>
            <span *ngIf="this.aiSourcingService.isAISourcingTab"  (click)="handleChildEvents('openNav', null, 'show-contact')">
                <span class="contactIcoBox" *ngIf="calledfrompage !== 'shortlistpage'"   matTooltip="Contact info available once shortlisted" [matTooltipClass]="{ 'red-tooltip text-black': true }" [ngClass]="{'shortlisted': calledfrompage == 'shortlistpage'}">
                <span><i class="fa-solid fa-envelope f-12"></i></span>
                <span><i class="fa-light fa-pipe f-12"></i></span>
                <span><i class="fa-solid fa-phone f-12"></i></span>
                </span>
              <span class="contactIcoBox" *ngIf="calledfrompage == 'shortlistpage'" matTooltip="Get contact details" [matTooltipClass]="{ 'red-tooltip text-black': true }" [ngClass]="{'shortlisted': calledfrompage == 'shortlistpage'}">
                <span><i class="fa-solid fa-envelope f-12"></i></span>
                <span><i class="fa-light fa-pipe f-12"></i></span>
                <span><i class="fa-solid fa-phone f-12"></i></span>
                </span>
            </span>

            </span>
<!--
            <div *ngIf="calledfrompage == 'resume-screen'">
              <p class="mb-1 text-truncate">{{data?.lastjob_title}} <span *ngIf="data?.lastjob_title && data?.job_company_name">at</span> {{data?.job_company_name | titlecase}}</p>
              <p class="m-0 text-9696 f-12" *ngIf="data?.location_name"> <i class="far fa-map-marker-alt mr-1 text-9696"></i> {{data?.location_name | titlecase}}</p>
            </div> -->

            <p class="f-16 icon-color mb-1 f-14 position-relative d-flex">
              <span class="d-flex w-100" (mouseenter)="getCompanyInfo('main',null, $event)" *ngIf="currentJobTitle">

                <span *ngIf="currentJobTitle" class="text-capitalize text-truncate"  matTooltip="{{currentJobTitle | titlecase}} at {{currentCompany | titlecase}}" [matTooltipClass]="{ 'red-tooltip': true }"
                  [innerHTML]="currentJobTitle"></span>
                <span *ngIf="currentJobTitle && currentCompany">&nbsp;at&nbsp;</span>
                <span *ngIf="currentCompany" class="position-relative text-capitalize" style="width: 200px; display:flex;"
                  [ngClass]="{'dstooltip pointer':primaryCompanyInformation?.website, companyHover: primaryCompanyInformation?.website}">
                  <span [innerHTML]="currentCompany" class="text-truncate"></span>
                  <span class="dstooltip-content">
                    <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                      *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                  </span>
                </span>
              </span>
              <span *ngIf="!currentJobTitle && currentSchool" class="text-capitalize">Student at {{currentSchool}}</span>
            </p>
          </div>
          <div *ngIf="!selectedCandididate?.length">
              <div class="d-flex position-relative" *ngIf="!data?.selected">
              <button data-testid="auto-app-ai-sourcing-profile-card-button-1" class="btn-trms-regular archive" (click)="changeCandidateStatus(data, 'archive')" *ngIf="calledfrompage == 'reviewpage' || calledfrompage == 'shortlistpage'">
              <i class="fa-solid fa-user-minus mr-1"></i> Archive
              </button>
              <button data-testid="auto-app-ai-sourcing-profile-card-button-2"  class="btn-trms-small ml-2 px-0" (click)="changeCandidateStatus(data, 'shortlisted')" *ngIf="calledfrompage == 'reviewpage' || calledfrompage == 'archivepage'">
                <i class="fa-solid fa-user-plus mr-1"></i>Shortlist
              </button>
              <button data-testid="auto-app-ai-sourcing-profile-card-button-3"  class="btn-trms-regular ml-2 px-2" (click)="openAddToEmailCampaign()" *ngIf="calledfrompage == 'shortlistpage'">
              <i class="fa-solid fa-envelopes-bulk mr-1"></i>Add to Email Campaign
              </button>
              <div class="archive-modal" *ngIf="archiveModal" [ngClass]="{'d-block':archiveModal,'d-none':!archiveModal}">
                <app-archive-candidate-modal [data]="data" (notifyParent)="receiveData($event)"></app-archive-candidate-modal>
              </div>
            </div>
          </div>
        </div>
        <p class="f-12 mb-1 d-flex align-items-center" style="width: 570px;">
          <i class="far fa-map-marker-alt mr-1 text-9696" *ngIf="currentLocation"></i>
          <span *ngIf="currentLocation" [innerHTML]="currentLocation"
            class="text-9696 text-capitalize text-truncate"></span>
          <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="currentLocation && totalTenure"></i>
          <span matTooltip="Total years of experience" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            class="text-9696 text-nowrap">
            <i class="far fa-briefcase mr-1" *ngIf="totalTenure"></i>
            <span *ngIf="totalTenure" class="text-9696">{{totalTenure}}</span>
          </span>

          <i class="fas fa-circle text-d9d9d9 mx-2 mr-1 text-9696" style="font-size:5px"
            *ngIf="totalTenure && data?.job_company_industry"></i>

          <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="currentLocation && !totalTenure && data?.job_company_industry"></i>
          <span matTooltip="Current Industry" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            class="text-9696 text-truncate">
            <i class="fa-sharp fa-regular fa-industry-windows mr-1" *ngIf="data?.job_company_industry"></i>
            <span *ngIf="data?.job_company_industry" class="text-9696">{{data?.job_company_industry |
              titlecase}}</span>
          </span>
          </p>
      </div>
        <!-- <div>
             <div class="d-flex" *ngIf="!data?.selected" style="width: 250px;">
            <button data-testid="auto-app-ai-sourcing-profile-card-button-4" class="btn-trms-regular archive" (click)="changeCandidateStatus(data, 'archive')" *ngIf="calledfrompage == 'reviewpage' || calledfrompage == 'shortlistpage'">
             <i class="fa-regular fa-user-minus mr-1"></i> Archive
            </button>
            <button data-testid="auto-app-ai-sourcing-profile-card-button-5"  class="ml-2 btn-trms-small px-0" (click)="changeCandidateStatus(data, 'shortlisted')" *ngIf="calledfrompage == 'reviewpage' || calledfrompage == 'archivepage'">
              <i class="fa-regular fa-user-plus mr-1"></i>Shortlist
            </button>
            <button data-testid="auto-app-ai-sourcing-profile-card-button-6"  class="ml-2 btn-trms-regular px-0" (click)="openAddToEmailCampaign()" *ngIf="calledfrompage == 'shortlistpage'">
            <i class="fa-solid fa-envelopes-bulk mr-1"></i>Add to Email Campaign
            </button>
          </div>
        </div> -->
    </div>
  </div>
  <!-- HightLight Section Commented -->
  <!-- <ng-container *ngIf="highlightsList?.length">
    <div class="d-flex align-items-baseline">
      <div class="d-flex justify-content-end w-100px">
        <span class="text-9696 mr-3 f-12">Highlights</span>
      </div>

      <div class="d-flex flex-wrap removengbtooltiparrow">
        <div *ngFor="let highlight of highlightsList.slice(0, 4)" class="highlight-pill"
          [ngClass]="'highlight-pill-' + highlight.color" [ngbTooltip]="highlight_chip_tooltip" placement="bottom">

          <i class="fa-solid fa-building mr-2" [ngClass]="'briefcase-blank-' + highlight.color"
            *ngIf="!highlight?.imageName"></i>
          <span *ngIf="highlight?.imageName">
            <img [src]="'assets/highlights/' + highlight.imageName + '.svg'" alt="">
          </span>
          <span class="ml-2">{{ highlight.label }}</span>

          <ng-template #highlight_chip_tooltip>
            <span class=" f-12">
              <span class="">

                <div
                  *ngIf="highlight.label !== 'Multi-Industry' && highlight.label !== 'Techie' && highlight.label !== 'Promotion Track' && highlight.label !== 'Unicorn Experience'
                                                      && highlight.label !== 'Same Location' && highlight.label !== 'Nearby Location' && highlight.label !== 'Role Compatibility'
                                                      && highlight.label !== 'Years of Experience' && highlight.label !== 'Company Size' && highlight.label !== 'Skills Matched'">
                  <div class="hiderule">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                        Candidate has {{ highlight.label.toLowerCase() }} :
                        <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                          {{ item | titlecase }}{{ !last ? ', ' : '.' }}
                        </span>
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Techie'">
                  <div class="hiderule">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                        Activity noticed on technology social networks like: GitHub, Stack Overflow,
                        Kaggle, etc.
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Multi-Industry'">
                  <div class="hiderule" *ngFor="let item of highlight.value">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Worked in <span
                          class="fw-600">{{item.name
                          |
                          capitalizeFirstLetter}}</span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.year || item.exp.month"> for </span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.year">{{(item.exp.year
                          == 1)? (item.exp.year +" Year"):(item.exp.year+" Years")}} </span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.year && item.exp.month">and </span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.month">{{(item.exp.month == 1)?
                          (item.exp.month +"
                          Month"):(item.exp.month+" Months")}} </span>
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Promotion Track'">
                  <div class="hiderule">
                    <div class="position-relative"
                      *ngIf="highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at both current and previous
                        companies.</span>
                    </div>
                    <div class="position-relative"
                      *ngIf="highlight.value?.currentjob_internal_movement && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at current company.</span>
                    </div>
                    <div class="position-relative"
                      *ngIf="highlight.value?.progression_within_pastcompany && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at previous company.</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Unicorn Experience'">
                  <div class="hiderule">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg">
                        Candidate has experience in a Unicorn company :
                        <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                          {{ capitalizeFirstLetter(item) }}{{ !last ? ', ' : '.' }} </span>
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Same Location' || highlight.label === 'Nearby Location'">
                  <div class="hiderule">
                    <div>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip"> This Candidate’s current location
                        <span class="text-capitalize" [innerHTML]="highlight.value"></span>
                        matches with your ideal profile.
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Role Compatibility' || highlight.label === 'Years of Experience'">
                  <div class="hiderule">
                    <div>
                      <span *ngIf="highlight.label === 'Role Compatibility'" class="font-weight-normal f-12 hl-mssg">The
                        candidate's
                        job
                        title as a <span class="font-weight-600 text-capitalize" [innerHTML]="highlight.titles"></span>
                        aligns
                        with a
                        closely matching
                        profile.
                      </span>

                      <span *ngIf="highlight.label === 'Years of Experience'" class="font-weight-normal f-12 hl-mssg">The
                        candidate
                        possesses over <span [innerHTML]="totalTenure"></span> years of
                        experience, which
                        closely aligns with your preferred profile.
                      </span>

                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Company Size' || highlight.label === 'Skills Matched'">
                  <div class="hiderule">
                    <div>

                      <span *ngIf="highlight.label === 'Company Size'" class="font-weight-normal f-12 hl-mssg"> This
                        candidates
                        has
                        worked in a
                        similar company size i.e. <span [innerHTML]="highlight.value"></span> in
                        the past.
                      </span>

                      <span *ngIf="highlight.label === 'Skills Matched'" class="font-weight-normal f-12 hl-mssg"> <span
                          class="text-capitalize" [innerHTML]="highlights.skills"></span>
                        skills present in this candidate that matches with your ideal profile.
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

              </span>
            </span>
          </ng-template>
        </div>

      </div>

      <p class="f-12 text-webbtree-green pointer" *ngIf="highlightsList && highlightsList.length > 4"
        (click)="handleChildEvents('openNav')">+ {{highlightsList.length - 4}} more</p>
    </div>
  </ng-container> -->
  <div>
    <div class="job-compalibility-summary pointer" (click)="handleChildEvents('openNav')"
      [ngClass]="{'gray-border-disabled': data?.screening_response?.overallscore == null}">
      <div class="gen-ai-text f-14"
        [ngClass]="{'text-9696': data?.screening_response?.overallscore == null}">
        <i class="fa-solid fa-stars"></i> Job Compatibility Summary
      </div>

      <div class="criteria-btn-wrapper">
        <div *ngIf="data?.screening_response?.overallscore !== null">
          <div class="potential-match-btn criteria-btn" [ngClass]="{
              'excellent-match-btn': data?.screening_response?.matchcategory == 'EXCELLENT',
              'good-match-btn': data?.screening_response?.matchcategory == 'GOOD',
              'potential-match-btn': data?.screening_response?.matchcategory == 'POTENTIAL',
              'notamatch-match-btn': data?.screening_response?.matchcategory == 'NOT_A_MATCH'
            }">
            {{showMatchScore(data?.screening_response?.matchcategory)}} | {{data?.screening_response?.overallscore |
            number:'1.0-0'}}%
            <!-- <i class="fa-solid fa-chevron-right"></i> -->

            <!-- Tooltip inside wrapper -->
            <div class="match-criteria">
              <p><strong>Overall Candidate Score</strong></p>
              <p>Check the Candidate Score and Fitment to see how well the profile matches the job</p>
              <p><i class="fa-solid fa-thumbs-up text-excellent"></i> <span style="color: #D9D9D9;"
                  class="mr-2 ml-2">|</span> <span class="text-excellent">Excellent Match</span><span
                  class="float-right">85%+ Above</span></p>
              <p><i class="fa-solid fa-thumbs-up text-good"></i> <span style="color: #D9D9D9;" class="mr-2 ml-2">|</span>
                <span class="text-good">Good Match</span><span class="float-right">60% - 85%</span>
              </p>
              <p><i class="fa-solid fa-thumbs-up text-potential"></i> <span style="color: #D9D9D9;"
                  class="mr-2 ml-2">|</span> <span class="text-potential">Potential Match</span><span
                  class="float-right">40% - 60%</span></p>
              <p><i class="fa-solid fa-thumbs-down text-danger"></i> <span style="color: #D9D9D9;"
                  class="mr-2 ml-2">|</span> <span class="text-danger">Not a Match</span><span class="float-right">0% -
                  40%</span></p>
            </div>
          </div>
        </div>
        <div>
          <button data-testid="auto-app-ai-sourcing-profile-card-button-7" class="btn-re-run-screen position-relative" (click)="rerunCandidate(data)"
            *ngIf="data?.doc_urls?.length && data?.screening_response?.overallscore == null && !showProgressBar">
            <span *ngIf="!showloadingScreening" class="gen-ai-text">Re-run Screen<span
                class="position-absolute f-10 gen-ai-text" style="top: 6px; font-size: 10px;">AI</span></span>

            <span *ngIf="showloadingScreening" class="gen-ai-text"><span class="gen-ai-text"><i
                  class="fa-regular fa-loader fa-spin gen-ai-text mr-1"></i></span> Screening</span>
          </button>
          <p *ngIf="!data?.doc_urls?.length && data?.screening_response?.overallscore == null && !showProgressBar">Unable to fetch relevant documents from ATS</p>
        </div>
      </div>

    </div>

    <!-- Handle for the Expand and Collapse All behaviour  -->
    <div class="expandAll-row" *ngIf="data?.screening_response?.overallscore !== null">
         <span *ngIf="calledfrompage != 'resume-screen'">Autopilot<sup style="top: -1px !important;"><span>AI</span></sup>
        Evaluation Insights</span>
      <span *ngIf="calledfrompage == 'resume-screen'">Screen<sup style="top: -1px !important;"><span>AI</span></sup>
        Evaluation Insights</span>
      <span class="expandAll pointer" *ngIf="!allExpanded" (click)="expandAll()">Expand All</span>
      <span class="expandAll pointer" *ngIf="allExpanded" (click)="collapseAll()">Collapse All</span>
    </div>

    <!-- Show Screening Criteria and Description as pe show hide condition  -->
    <div class="collapsible-section">
      <div class="card-row" *ngFor="let criteria of data?.screening_response?.screening_criteria; let i = index">
        <div class="collapsible-row">
          <p>
            <a data-testid="auto-app-ai-sourcing-profile-card-a-1" role="button" class="showicon pointer" (click)="toggleCollapse(i)"
              [ngClass]="{'text-9696': data?.screening_response?.overallscore == null}">
              <span>
                {{ criteria.criteria_content | titlecase }}
                <span *ngIf="data?.screening_response?.overallscore !== null">
                  <i class="fa-solid fa-thumbs-up ml-1"
                    *ngIf="criteria?.match === 'full' || criteria?.match === 'partial' || criteria?.match === 'good'"
                    [ngStyle]="{ color: criteria?.match === 'full' ? '#229300' : criteria?.match === 'partial' ? '#FBA744': criteria?.match === 'good' ? '#CBCE66': 'inherit'}">
                  </i>
                  <i class="fa-solid fa-thumbs-down ml-1" *ngIf="criteria?.match === 'unmatched'"
                    [ngStyle]="{ color: criteria?.match === 'unmatched' ? '#CD0F0F8C' : 'inherit'}">
                  </i>
                </span>
                <span *ngIf="data?.screening_response?.overallscore == null" matTooltip="Unable to run ScreenAI"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <i class="fa-solid fa-circle-exclamtion ml-1 text-9696"></i>
                </span>
              </span>

              <span class="ml-2" *ngIf="data?.screening_response?.overallscore !== null">
                <i class="fa-regular fa-chevron-down" *ngIf="expandedStates[i] == false"></i>
                <i class="fa-regular fa-chevron-up" *ngIf="expandedStates[i] == true"></i>
              </span>
            </a>
          </p>

          <div class="collapse" [ngClass]="{ 'show': expandedStates[i] }" *ngIf="data?.screening_response?.overallscore !== null">
            <div class="collapse-description">
              <span class="f-12" [innerHtml]="criteria.explanation"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #addCandidateToEmailCampaign>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
    <button data-testid="auto-app-ai-sourcing-profile-card-button-8" type="button" class="close font-weight-normal ms-auto btn p-0 f-20"  data-dismiss="modal" aria-label="Close"
      (click)="closeActiveModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-2 mt-2">
      <div class="col">
        <input data-testid="auto-app-ai-sourcing-profile-card-input-1" type="text" name="campaign_name" class="wc-form-control no-shadow w-100 inputheight mb-2"
          placeholder="Enter Campaign Name...." [formControl]="campaign_input" [matAutocomplete]="campaign_name"
          (input)="onTypeAheadSearch($event.target.value)" (click)="onTypeAheadSearch($event.target.value)" />
        <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
          class="f-12 text-danger">Campaign Name is required</p>
        <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
          <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="row mb-0">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-ai-sourcing-profile-card-button-9" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaign()"
          [disabled]="!campaign_input.valid && isLoadingEmailCampaignApi" >
             <span [ngClass]="{ 'spinner-border spinner-size': isLoadingEmailCampaignApi }"
            [ngStyle]="{ 'width: 20px; height: 20px;': isLoadingEmailCampaignApi }">
            {{isLoadingEmailCampaignApi ? '' : 'Add'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span> <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600" style="text-decoration: underline;" (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)">"{{campaignName}}".</span></p>
  </div>
</ng-template>
